// The platform's own identity and its tool registry: both EC and IM appear
// here, which is why it is shared rather than owned by either. The logo
// imports reach app/javascript/images/, which belongs to neither app.
import ECLogo from "../../images/ec.svg";
import IMLogo from "../../images/im.svg";

export const platformConfig = {
  welcomeMessage: `
    ICER Analytics™ is a new cloud-based platform that facilitates the use of ICER’s
    evidence reports and underlying analyses by decision-makers as they develop medical policy,
    establish drug pricing, and negotiate drug reimbursement.
  `,
  tools: [
    {
      id: "ec",
      name: "Evidence Compendium",
      description: "Streamline the use of ICER analyses so you can make the best decisions",
      details: [
        "Enter your own pricing to compare to ICER price benchmarks",
        "View curated report material and videos from ICER appraisal committee meetings",
      ],
      to: "/drugs",
      image: ECLogo,
    },
    {
      id: "im",
      name: "Interactive Modeler",
      description: "Share your assumptions based on new evidence using ICER's models",
      details: [
        "Analyze key aspects of individual economic models produced for ICER Evidence Reports",
        "Customize parameter inputs to the model based on your prices, data, or assumptions",
      ],
      href: window.env.IM_URL,
      image: IMLogo,
    },
  ],
};
